export const environment = {
  production: false,
  // apiUrl: 'http://localhost:3021',
  aesKey: 'MyStrong32CharKey@123',
    apiUrl: 'https://dev.awasbandhu.upda.co.in/api',
};
